<mat-paginator
	#paginator
	[length]="totalItems"
	[pageSize]="pageSize"
	[pageSizeOptions]="pageSizeOptions"
	[showFirstLastButtons]="true"
>
</mat-paginator>
